<arm-layout [summaryTitle]="'NETWORK SUMMARY'">
    <div header>
        <div class="search-container">
            <arm-search [searchComponent]="mapSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms"
                        [localSearch]="true"
                        (onSearch)="onSearch($event)">
            </arm-search>
        </div>

        <div class="action-buttons">

            <arm-action-bar (editClick)="editItem()" (refreshClick)="manualRefreshMap()" (deleteClick)="deleteItem()"
                            [disableDelete]="!isAuthorized || isDeleteItemDisabled()"
                            [disableEdit]="!isSingleSelection() || isConnectionsCluster()">
            </arm-action-bar>

            <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="addConnection()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Add connection</span>
                </button>
                <button (click)="dragConnectionMode()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Drag Connection</span>
                </button>
                <button (click)="testRoute()" [disabled]="isAnyElementsOnMap() || isTestRouteDisabled" mat-menu-item>
                    <span>Test Route</span>
                </button>
                <button (click)="importNodesFromTopology()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Import nodes</span>
                </button>
                <button (click)="importFromTopology()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Import Topology</span>
                </button>
                <button (click)="clearOfflineMap()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Clear Map</span>
                </button>
                <button [matMenuTriggerFor]="lockUnlock" mat-menu-item
                        [disabled]="(!isOnlyPConsSelected() && !isOnlyNodeSelected())">
                    <span>Lock\Unlock</span>
                </button>
            </mat-menu>

            <mat-menu #lockUnlock="matMenu">
                <button (click)="lockItem()"  mat-menu-item>
                    <span>Lock</span>
                </button>
                <button (click)="lockPConsForIncoming()" *ngIf="isOnlyPConsSelected()" mat-menu-item>
                    <span>Lock Incoming</span>
                </button>
                <button (click)="lockPConsForOutgoing()" *ngIf="isOnlyPConsSelected()" mat-menu-item>
                    <span>Lock Outgoing</span>
                </button>
                <button (click)="unlockItem()" mat-menu-item>
                    <span>Unlock</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div summary>
        <offline-map-summary-container [diagramSelection]="diagramSelection"></offline-map-summary-container>
    </div>

    <div main>
        <offline-map-diagram [(diagramApi)]="diagramApi" (diagramItemAdded)="diagramItemAdded($event)"
                     (edgeDragged)="createConnection($event)" (onDiagramSelect)="onDiagramSelect($event)"
                     class="drop-shadow-gray-border main-view-panel height-adjustment"></offline-map-diagram>
    </div>
</arm-layout>
